import React from "react";

function Stakers(){

    return(
        <div>
            <div className="row">
                <div className="side">
                    <h2 style={{"textAlign":"center"}}>Stakings Available</h2>
                    <h3 style={{"textAlign":"center"}}>sCTMT Staking</h3>
                    <p style={{"textAlign":"justify"}}>Four percentum (4%) of all managers earnings are rewarded to sCTMT holders. 
                        Stake or unstake your CTMT at the current prevailing price of sCTMT. </p>
                    <h3 style={{"textAlign":"center"}}>cMnsta Staking</h3>
                    <p style={{"textAlign":"justify"}}>Four percentum (4%) of all managers earnings are rewarded to sCTMT holders. 
                        Purchase and baking of monsta happens for every accumulation of $1,000.00
                        Stake or unstake your bMonsta at the current prevailing price of cMnsta. </p>
                    <h3 style={{"textAlign":"center"}}>odMnst Staking</h3>
                    <p style={{"textAlign":"justify"}}>It is a retirement fund for bmonsta holders. The staking will get 1 odMnst in exchange of 1.67 bMonsta.
                        The program is only unstakeble after 10 years or when the contract able to back 1 CTMT for every 1.67 bMonsta whichever is earlier. 
                        Two percentum of declared surplus of managers is accumulated in this program. </p>
                </div>
                <div className="main">
                    <h2>Staking Projects</h2>
                    <table style={{"width": "100%"}}>
                    <td style={{"text-align": "center"}}>
                        <h3>sCTMT</h3>
                        <h5>Stake CTMT</h5>
                        <p>Current Price: </p>
                        <button type="button">Approve</button><br /><br /><br />
                        <form >
                        <input type="number"  value="Doe" /> <button>Stake</button>
                        <p>Max.: </p>
                        </form><br />
                        <form >
                        <input type="number"  value="Doe" /> <button>Unstake</button>
                        <p>Max.: </p>
                        </form><br />
                    </td>
                    <td style={{"text-align": "center"}}>
                        <h3>cMnsta</h3>
                        <h5>Stake bMonsta</h5>
                        <p>Current Price: </p>
                        <button type="button">Approve</button><br /><br /><br />
                        <form >
                        <input type="number"  value="Doe" /> <button>Stake</button>
                        <p>Max.: </p>
                        </form><br />
                        <form >
                        <input type="number"  value="Doe" /> <button>Unstake</button>
                        <p>Max.: </p>
                        </form><br />
                    </td>
                    <td style={{"text-align": "center"}}>
                        <h3>odMnst</h3>
                        <h5>Stake bMonsta</h5>
                        <p>Current Price: </p>
                        <button type="button">Approve</button><br /><br /><br />
                        <form >
                        <input type="number"  value="Doe" /> <button>Stake</button>
                        <p>Max.: </p>
                        </form><br />
                        <form >
                        <input type="number"  value="Doe" /> <button>Unstake</button>
                        <p>Max.: </p>
                        </form><br />
                    </td>
                    </table>
                </div>
            </div>
        </div>
        
    )
}

export default Stakers;